import type { DirectiveBinding } from 'vue'
import { gsap } from 'gsap'

export const vMagnetic = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const strength = binding.value || 20 // Max pixels to move

    // Resting box of the element, measured once per hover instead of on every mousemove
    let rest: { left: number; top: number; width: number; height: number } | null = null

    const measure = () => {
      const rect = el.getBoundingClientRect()
      // Subtract the offset we applied ourselves, so re-entering mid-animation stays accurate
      rest = {
        left: rect.left - (gsap.getProperty(el, 'x') as number),
        top: rect.top - (gsap.getProperty(el, 'y') as number),
        width: rect.width,
        height: rect.height,
      }
      return rest
    }

    const onMouseMove = (e: MouseEvent) => {
      const r = rest ?? measure()
      // Calculate distance from center of element
      const x = e.clientX - r.left - r.width / 2
      const y = e.clientY - r.top - r.height / 2

      // Move element towards mouse
      gsap.to(el, {
        x: (x / r.width) * strength,
        y: (y / r.height) * strength,
        duration: 0.3,
        ease: 'power3.out',
        overwrite: 'auto',
      })
    }

    const onMouseLeave = () => {
      rest = null
      // Snap back to center
      gsap.to(el, {
        x: 0,
        y: 0,
        duration: 0.7,
        ease: 'elastic.out(1, 0.3)',
        overwrite: 'auto',
      })
    }

    el.addEventListener('mousemove', onMouseMove)
    el.addEventListener('mouseleave', onMouseLeave)

    // Store handlers for cleanup
    ;(el as any)._magneticCleanup = () => {
      el.removeEventListener('mousemove', onMouseMove)
      el.removeEventListener('mouseleave', onMouseLeave)
      gsap.killTweensOf(el)
    }
  },
  unmounted(el: HTMLElement) {
    if ((el as any)._magneticCleanup) {
      (el as any)._magneticCleanup()
    }
  }
}
